<h1 class="sr-only">Dashboard</h1>

<ng-template [ngTemplateOutlet]="dashboard" [ngTemplateOutletContext]="{ $implicit: externalUrl }"></ng-template>

<ng-template #externalDashboard>
  <div class="animated fadeIn">
    <div class="row">
      <iframe
        [src]="cleanURL(externalUrl)"
        frameborder="0"
        height="100%"
        id="iframe_startpage"
        sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin"
        style="-webkit-transform:scale(1.0);-moz-transform-scale(1.0); border: none; display: block; height:calc(100vh - 10px); overflow: hidden;"
        width="100%"></iframe>
    </div>
  </div>
</ng-template>

<ng-template #internalDashboard>
  @if (deploymentMode === "PUBLIC") {
    <h1 class="mt-3" style="padding-top: 8rem">
      {{ "layouts.page.title" | translate }}
    </h1>
  } @else {
    <div>
      <div class="row">
        <cap-logo></cap-logo>
      </div>
    </div>
  }
  <cap-rechte-hinweis></cap-rechte-hinweis>
</ng-template>
